import * as Yup from 'yup'
import { FormDuufFieldData, FormDuufSchema } from './FormDuuf'

interface ShapeProps {
  [key: string]: Yup.BaseSchema
}

const schema = (fields: Array<FormDuufFieldData>, yupSchema: FormDuufSchema) => {
  const form: ShapeProps = {}

  fields.forEach((field) => {
    let validator = null
    const fieldId: string = `input_${field.id}`

    if (yupSchema[fieldId]) {
      validator = yupSchema[fieldId]
    } else if (field.type === 'consent') {
      validator = Yup
        .boolean()
        .oneOf([true], field.errorMessage || 'consent')
        .required()
    } else {
      validator = Yup.string()

      if (field.isRequired) {
        validator = validator.required(field.errorMessage || 'required')
      }

      if (field.type === 'email') {
        validator = validator.email(field.errorMessage || 'email')
      }
    }

    form[fieldId] = validator
  })

  return Yup.object().shape(form)
}

export default schema
